module.exports = __webpack_public_path__ + "media/images/favicon-16x16-ce9e486cf813998beaff5b222759adee.png";